import { Required } from 'utility-types'
import { ActivityMapper as CommuteActivityPicker } from 'shared/components/common/CommuteActivityPicker'
import { AddressPoint, Frequency, Route } from 'shared/interfaces/Commute'
import { ComposedInputComponentProps } from 'shared/interfaces/Survey'
import { useConfig } from 'shared/providers'

export interface IActivityMapperProps {
  // Antd form item id
  id?: string
  primaryRoute: Route
  primaryRouteFrequency: Frequency
  secondaryRoute?: Route
  secondaryRouteFrequency?: Frequency
}
type ActivityMapperValueProp = {
  frequency: Frequency
  stopLocations: AddressPoint[]
  keys: number[]
  routes: string[]
} & Record<string, { legIndex: number }>
export type ActivityMapperProps = Required<Partial<ComposedInputComponentProps<ActivityMapperValueProp>>, 'question'> &
  IActivityMapperProps

function ActivityMapper({
  id,
  question,
  primaryRoute,
  primaryRouteFrequency,
  secondaryRoute,
  secondaryRouteFrequency,
  validation
}: ActivityMapperProps) {
  const {
    theme: { currentTheme }
  } = useConfig()
  const routes = [{ ...primaryRoute, frequency: primaryRouteFrequency }]
  if (secondaryRoute && secondaryRouteFrequency) {
    routes.push({ ...secondaryRoute, frequency: secondaryRouteFrequency })
  }

  return (
    <CommuteActivityPicker
      id={id}
      questionId={question.id}
      defaultValidation={validation}
      routes={routes}
      theme={currentTheme}
    />
  )
}

export default ActivityMapper
